const reducers = {
    customer(state, action) {
      state.customer = action.payload.customer
    }
  }
  
  export default reducers;
  